module.exports = __webpack_public_path__ + "static/media/lovina-beach.41905692.jpg";